export const locale = {
  lang: 'es',
  data: {
    'CONFIRM': {
      'CONFIRM': 'Confirmar',
      'CANCEL': 'Cancelar',
    },
  }
};
